// extracted by mini-css-extract-plugin
export default {"previewEmail":"PlD4gGkWOXPq9tqq6oC0"};